export const SEARCH_HISTORY_TEXTS = {
  title: 'История поиска',
} as const;

export const HISTORY_CARD_TEXTS = {
  priceFrom: 'от',
  dateFrom: 'с',
  dateTo: 'по',
  nights: 'ночей',
  touristForms: ['турист', 'туриста', 'туристов'],
} as const;
